import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import {
  withStyles,
  FormControl,
  InputLabel,
  FormHelperText,
  Input,
}  from '@material-ui/core';

import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';

function CustomInput({
  'data-testid': dataTestId,
  disabled,
  classes,
  error,
  formControlProps,
  helpText,
  id,
  inputProps,
  inputRootCustomClasses,
  labelProps,
  labelText,
  name,
  onChange,
  required,
  success,
  value,
  white,
}) {
  const labelClasses = classNames({
    [` ${classes.labelRoot}`]       : Boolean(classes.labelRoot),
    [` ${classes.labelRootError}`]  : error,
    [` ${classes.labelRootSuccess}`]: success && !error,
  });
  const underlineClasses = classNames({
    [classes.underlineError]  : error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]       : true,
    [classes.whiteUnderline]  : white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  const inputClasses = classNames({
    [classes.input]     : true,
    [classes.whiteInput]: white,
  });

  let formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  const helpTextClasses = classNames({
    [classes.labelRootError]  : error,
    [classes.labelRootSuccess]: success && !error,
  });
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        <InputLabel
          required={required}
          error={error}
          className={`${classes.labelRoot} ${labelClasses}`}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        onChange={onChange}
        disabled={disabled}
        value={value}
        error={error}
        classes={{
          input    : inputClasses,
          root     : marginTop,
          disabled : classes.disabled,
          underline: underlineClasses,
        }}
        name={name}
        id={id}
        inputProps={{
          'data-testid': dataTestId,
        }}
        {...inputProps}
      />
      {helpText !== undefined ? (
        <FormHelperText id={`${id}-text`} className={helpTextClasses} mt={10}>
          {helpText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  'data-testid'         : PropTypes.string,
  disabled              : PropTypes.bool,
  classes               : PropTypes.object.isRequired,
  error                 : PropTypes.bool,
  formControlProps      : PropTypes.object,
  helpText              : PropTypes.node,
  id                    : PropTypes.string,
  inputProps            : PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  labelProps            : PropTypes.object,
  labelText             : PropTypes.node,
  name                  : PropTypes.string,
  onChange              : PropTypes.func,
  required              : PropTypes.bool,
  success               : PropTypes.bool,
  value                 : PropTypes.string,
  white                 : PropTypes.bool,
};

CustomInput.defaultProps = {
  'data-testid'         : undefined,
  disabled              : false,
  error                 : undefined,
  formControlProps      : undefined,
  helpText              : undefined,
  id                    : undefined,
  inputProps            : undefined,
  inputRootCustomClasses: undefined,
  labelProps            : undefined,
  labelText             : undefined,
  name                  : undefined,
  onChange              : undefined,
  required              : undefined,
  success               : undefined,
  value                 : undefined,
  white                 : undefined,

};

export default withStyles(customInputStyle)(CustomInput);
